import { Component, Input, OnInit } from '@angular/core';
import { UiStateService } from '../shared/ui-state.service';
import { PassportService } from '../shared/passport.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-receiver-status-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './receiver-status-tabs.component.html',
  styleUrl: './receiver-status-tabs.component.css'
})
export class ReceiverStatusTabsComponent implements OnInit {
  @Input() shuntingCount = 0;
  @Input() receivingCount = 0;
  @Input() completedCount = 0;
  @Input() showShuntingTab = true; // Control visibility of shunting tab

  constructor(public ui: UiStateService, public passports: PassportService) {}

  // Directly use the UI state service's signal
  get selected() {
    return this.ui.statusSelected;
  }

  ngOnInit(): void {
    // Initialize with appropriate default tab
    if (!this.ui.statusSelected()) {
      // If shunting tab is hidden, default to receiving (outgoing)
      // Otherwise default to shunting (pending)
      const defaultTab = this.showShuntingTab ? 'pending' : 'outgoing';
      this.ui.setStatusSelected(defaultTab);
    } else if (this.ui.statusSelected() === 'pending' && !this.showShuntingTab) {
      // If currently on shunting tab but it's now hidden, switch to receiving
      this.ui.setStatusSelected('outgoing');
    }
  }

  setSelected(tab: 'pending' | 'outgoing' | 'completed'): void {
    this.ui.setStatusSelected(tab);
  }
}

